import { render, staticRenderFns } from "./LoanPlanChange.vue?vue&type=template&id=5525f584&"
import script from "./LoanPlanChange.vue?vue&type=script&lang=js&"
export * from "./LoanPlanChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports